export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9400.910fe21b.jpg";